import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { initTracking, storeConsent, getStoredConsent } from "@/lib/tracking";

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    initTracking();
    if (!getStoredConsent()) setVisible(true);
  }, []);

  if (!visible) return null;

  const choose = (choice) => {
    storeConsent(choice);
    setVisible(false);
  };

  return (
    <div
      data-testid="cookie-consent"
      role="dialog"
      aria-label="Cookie-Einwilligung"
      className="fixed inset-x-0 bottom-0 z-50 border-t border-sand bg-creme/95 backdrop-blur-md"
    >
      <div className="mx-auto flex max-w-7xl flex-col gap-3 px-4 py-4 sm:flex-row sm:items-center sm:justify-between sm:gap-5 sm:px-8 sm:py-6">
        <p className="max-w-2xl text-xs leading-relaxed text-stone sm:text-sm">
          Wir nutzen Cookies und vergleichbare Technologien, um unsere Website zu betreiben und –
          nur mit eurer Einwilligung – die Wirksamkeit unserer Anzeigen zu messen. Details findet
          ihr in unserer{" "}
          <Link
            to="/datenschutz"
            className="font-semibold text-ink underline decoration-sand underline-offset-2 hover:text-moss"
          >
            Datenschutzerklärung
          </Link>
          .
        </p>
        <div className="flex shrink-0 gap-2 sm:gap-3">
          <button
            type="button"
            data-testid="consent-accept"
            onClick={() => choose("granted")}
            className="flex-1 rounded-full bg-moss px-5 py-2.5 text-xs font-bold text-creme transition-colors duration-300 hover:bg-mossdeep sm:flex-none sm:px-7 sm:py-3 sm:text-sm"
          >
            Alle akzeptieren
          </button>
          <button
            type="button"
            data-testid="consent-decline"
            onClick={() => choose("denied")}
            className="flex-1 rounded-full border border-stone/40 px-5 py-2.5 text-xs font-semibold text-ink transition-colors duration-300 hover:border-ink sm:flex-none sm:px-7 sm:py-3 sm:text-sm"
          >
            Nur notwendige
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
